import './news-detail/news-detail.less';
import './news-list/news-list.less';

require('es6-promise').polyfill();

$(function () {
    if ($('.news-detail-item').length > 0) {
        import('./news-detail/news-detail').then(function (module) {
            module.default;
        });
    }

    $('.add-comment-link').on('click', function (event) {
        event.preventDefault();
        $(this).hide();
        $('.comment-new').show();
    });
});
